import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Letter from './pages/Letter';
import Photo from './pages/Photo';

function App() {
    return (
        <div className='App'>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/letter' element={<Letter />} />
                    <Route path='/photo' element={<Photo />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
